<script setup lang="ts">
/**
 * Nominee Director / Nominee Shareholder Notice 공통 — PARTICULARS OF NOMINATOR (INDIVIDUAL / LEGAL ENTITY) 두 표.
 *   키는 두 템플릿 공통(nominator_*). DocScope(nd_{id}/ · ns_{id}/) 안에서 렌더돼 부수별로 분리된다.
 *   active=false(“No”) 면 문서에서도 비워지므로(normalize) 화면도 흐리게 표시.
 */
import CddVarField from './cdd/CddVarField.vue';

defineProps<{ active: boolean }>();

const IND: Array<[string, string]> = [
  ['Full Name:', 'nominator_full_name'],
  ['Alias (if any):', 'nominator_alias'],
  ['Residential Address:', 'nominator_residential_address'],
  ['Email address:', 'nominator_email'],
  ['Contact number:', 'nominator_contact_no'],
  ['Nationality:', 'nominator_nationality'],
  ['Identification number:', 'nominator_identification_no'],
  ['Date of Birth:', 'nominator_date_of_birth'],
  ['Date of nomination:', 'nominator_date_of_nomination'],
];
const ENT: Array<[string, string]> = [
  ['Name:', 'nominator_entity_name'],
  ['Unique entity number, if any:', 'nominator_entity_uen'],
  ['Address of registered office:', 'nominator_registered_office_address'],
  ['Email address:', 'nominator_entity_email'],
  ['Contact number:', 'nominator_entity_contact_no'],
  ['Legal form of the legal entity:', 'nominator_legal_form'],
  ['Jurisdiction where and statute under which the legal entity is formed or incorporated:', 'nominator_jurisdiction'],
  ['Name of the corporate entity register where the legal entity was formed or incorporated, if any:', 'nominator_corporate_register_name'],
  ['Identification number or registration number on the corporate entity register of the jurisdiction where the legal entity is formed or incorporated, if any:', 'nominator_corporate_register_no'],
  ['Date of nomination:', 'nominator_entity_date_of_nomination'],
];
</script>

<template>
  <div :class="{ 'nom-off': !active }">
    <table class="cdd-tbl nom-tbl">
      <tbody>
        <tr><td colspan="2" class="cdd-sec">PARTICULARS OF NOMINATOR (INDIVIDUAL)</td></tr>
        <tr v-for="[label, key] in IND" :key="key">
          <td class="cdd-lcell">{{ label }}</td>
          <td><CddVarField :field-key="key" :label="label.replace(/:$/, '')" /></td>
        </tr>
      </tbody>
    </table>
    <table class="cdd-tbl nom-tbl">
      <tbody>
        <tr><td colspan="2" class="cdd-sec">PARTICULARS OF NOMINATOR (LEGAL ENTITY)</td></tr>
        <tr v-for="[label, key] in ENT" :key="key">
          <td class="cdd-lcell">{{ label }}</td>
          <td><CddVarField :field-key="key" :label="label.replace(/:$/, '')" /></td>
        </tr>
      </tbody>
    </table>
    <p v-if="!active" class="doc-p nom-note">Reply is “No” — nominator particulars are left blank in the generated notice.</p>
  </div>
</template>

<style scoped>
.nom-tbl { margin-top: 10px; }
.cdd-sec { font-weight: 700; background: #f3f5f9; text-align: center; }
.nom-tbl .cdd-lcell { width: 46%; }
.nom-off { opacity: 0.55; }
.nom-note { font-size: 11px; color: #6b7280; font-style: italic; }
</style>
